import util from "@/option/common/util.js";
import { inject, useAttrs } from "vue";
import moment from "moment";

/**
 * 根据config自动设置根节点数据
 * @param data 页面的data配置
 * @param config 组件配置schema
 */
export function autoSetRootData(config, data, obj, key) {
	if (findRootDataByConfig(config, data)) return;
	// 数据绑定是否有定制的key，默认为dynamicNode
	if (obj && key) {
		obj[key] = config.ref;
	} else {
		config.prop.dynamicNode = config.ref;
	}
	data.push({
		id: `d_${util.getIndex()}`,
		key: config.ref,
		type: "object",
		value: {},
		label: config.name + "的联动数据",
		linkData: true, // 自动生成的联动数据标识
	});
}

export function findRootDataByConfig(config, data) {
	return data.find((el) => el.key === config.ref);
}

export function findRootDataByKey(key, data) {
	return data.find((el) => el.key === key);
}

// 根据ref自动删除生成的数据
export function delRootDataByRef(ref, data) {
	if (Array.isArray(data))
		for (let i = 0; i < data.length; i++) {
			let el = data[i];
			if (el.key === ref) {
				return data.splice(i, 1);
			} else if (el?.children?.length) {
				delRootDataByRef(ref, el.children);
			}
		}
}

// 设置联动数据的 数据结构
export function setLinkDataStructure(config, list, rootData) {
	// 找到该节点 把相应的数据结构存储起来
	let data = findRootDataByConfig(config, rootData);
	data.children = [];
	list.forEach((el) => {
		data.children.push({
			id: `d_${util.getIndex()}`,
			key: el.fieldKey,
			type: el.fieldType || el.modelFieldType || "string",
			value: "",
			label: el.fieldName,
			linkData: true, // 自动生成的联动数据标识
		});
	});
}

// 为跟节点data设置数据结构
/**
 *
 * @param key data 数据的key
 * @param item 需要添加的子项
 * @param rootData 根节点数据
 */
export function setDataChildren(rootData, key, item) {
	// 找到该节点 把相应的数据结构存储起来
	let data = util.deepGetDataEditStatus(rootData, key);
	if (!Array.isArray(data.children)) {
		data.children = [];
	}
	let index = data.children.findIndex((el) => el.key === item.key);
	if (index > -1) {
		data.children[index] = item;
	} else {
		data.children.push(item);
	}
	// {
	// 	id: `d_${util.getIndex()}`,
	// 		key: el.fieldKey,
	// 	type: "string",
	// 	value: "",
	// 	label: el.fieldName,
	// 	linkData: true, // 自动生成的联动数据标识
	// }
}

let defaultColors = [
	["#0189fd", "#fe9204", "#11aa50", "#ffd003", "#7262ed", "#69c4eb", "#6c738e", "#ff745b", "#007d99", "#ffa8a8"],
	["#016dcb", "#017ae4", "#0189fd", "#33a1ff", "#4eabfe", "#66b8fe", "#7fc3fe", "#9acfff", "#cce6fe", "#e5f3fe"],
	["#ff2c43", "#ff9c6f", "#feccb4", "#fcdca5", "#fcc664", "#cb9742", "#8e736b"],
	["#008cfa", "#00bbf6", "#6fdeec", "#58edec", "#30d8bf", "#00c5aa", "#2ba3a5"],
	[
		"#188efc",
		"#3ed0be",
		"#2dbb58",
		"#95de59",
		"#f1c513",
		"#de9159",
		"#21306e",
		"#7160c5",
		"#8141d9",
		"#5a8be1",
		"#12bbbb",
		"#12bdbd",
		"#599dde",
		"#3335c2",
		"#9a7cde",
		"#e94661",
		"#c93ed0",
	],
];

export function getSetColors(index) {
	return defaultColors[index];
}

export function getColors(prop) {
	if (prop.colorType === "default") {
		return getSetColors(prop.selectedColorIndex);
	} else if (prop.colorType === "self") {
		return prop.customColor.split(",");
	}
}

export function formatValue(set, el, key) {
	if (set) {
		if (set?.nullList?.length) {
			set.nullList.forEach((_el) => {
				// 满足替换条件就替换默认值
				if (_el === "null" && el[key] === null) {
					el[key] = set.nullValue;
				}
				if (_el === "emptyString" && el[key] === "") {
					el[key] = set.nullValue;
				}
				if (_el === "0" && el[key] === 0) {
					el[key] = set.nullValue;
				}
			});
		}
		if (set.type === "number" && "digits" in set) {
			el[key] = typeof el[key] === "number" ? el[key].toFixed(set.digits) : parseFloat(el[key]).toFixed(set.digits);
		}
		if (set.type === "number" && set.splitMark) {
			el[key] = util.getNumberSplit(el[key]);
		}
		if (set.type === "date") {
			// 时间格式化
			if (set.dateFormat) {
				try {
					el[key] = moment(el[key]).format(set.dateFormat);
				} catch (e) {
					console.log(e);
				}
			}
		}
	}
}
